import { render } from "./Gstr2b.vue?vue&type=template&id=26927073"
import script from "./Gstr2b.vue?vue&type=script&lang=js"
export * from "./Gstr2b.vue?vue&type=script&lang=js"

import "./Gstr2b.vue?vue&type=style&index=0&id=26927073&lang=css"
script.render = render

export default script